import { requestApi } from 'api/api'
import type {
  HppPaymentMethodsPayload,
  HppPaymentMethodsResponse,
  RemoteWalletProvidersPayload,
  RemoteWalletProvidersResponse,
} from 'types/hppSettings'

export const getHppPaymentMethods = (): Promise<HppPaymentMethodsResponse> =>
  requestApi({ url: '/payment/v3/methods', method: 'GET', baseUrl: process.env.API_URL })

export const putHppPaymentMethods = (
  data: HppPaymentMethodsPayload
): Promise<HppPaymentMethodsResponse> =>
  requestApi({ url: '/payment/v3/methods', method: 'PUT', data, baseUrl: process.env.API_URL })

export const getHppRemoteWalletProviders = (): Promise<RemoteWalletProvidersResponse> =>
  requestApi({
    url: '/payment/v3/remote-wallet-providers',
    method: 'GET',
    params: { pageSize: 500 },
    baseUrl: process.env.API_URL,
  })

export const postHppRemoteWalletProviders = (data: RemoteWalletProvidersPayload): Promise<void> =>
  requestApi({
    url: '/payment/v3/remote-wallet-providers/actions',
    method: 'POST',
    data,
    baseUrl: process.env.API_URL,
  })
